namespace RioERP.Products {
    export interface ProductBillingItemSpecificationsForm {
        ProductId: Serenity.LookupEditor;
        ProductBillingItemId: Serenity.LookupEditor;
        ProductSpecificationId: Serenity.LookupEditor;
        PriceAdjustment: Serenity.DecimalEditor;
        EAdjustmentType: Serenity.EnumEditor;
        IsApplicable: Serenity.BooleanEditor;
    }

    export class ProductBillingItemSpecificationsForm extends Serenity.PrefixedContext {
        static formKey = 'Products.ProductBillingItemSpecifications';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductBillingItemSpecificationsForm.init)  {
                ProductBillingItemSpecificationsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.DecimalEditor;
                var w2 = s.EnumEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(ProductBillingItemSpecificationsForm, [
                    'ProductId', w0,
                    'ProductBillingItemId', w0,
                    'ProductSpecificationId', w0,
                    'PriceAdjustment', w1,
                    'EAdjustmentType', w2,
                    'IsApplicable', w3
                ]);
            }
        }
    }
}
